import {
	useGetPointTemplatesByIdsSingleVoyageQuery
} from "@containers/singleVoyage/pointTemplates/queryHooks/usePointTemplatesSingleVoyageQuery";
import {convertArrayToObj} from "@helpers/convert/convert";
import {useCallback, useMemo} from "react";
import {IPointTemplatesSingleVoyage} from "@containers/singleVoyage/pointTemplates/types";

export function useGetPointTemplateByIdsSingleVoyages({
														  accountId,
														  ids,
														  enabled
													  }: {
	accountId: number
	ids: number[]
	enabled?: boolean
}): {
	getPointTemplateById: (id: number) => IPointTemplatesSingleVoyage | null
	isLoading: boolean
	isFetching: boolean
} {
	const {
		data,
		isLoading,
		isFetching
	} = useGetPointTemplatesByIdsSingleVoyageQuery({
		accountId,
		enabled,
		ids
	})
	const map = useMemo(() => {
		if (!data?.length) {
			return {}
		}
		return convertArrayToObj({
			arr: data,
			key: 'id'
		})
	}, [data])
	
	const getPointTemplateById = useCallback((id: number): IPointTemplatesSingleVoyage | null => {
		if (!map || !(id in map)) {
			return null
		}
		return map[id]
	}, [map])
	
	return {
		isLoading,
		isFetching,
		getPointTemplateById
	}
}